type Gender = "male" | "female";

interface BodyMetrics {
  weight: number; // en kg
  height: number; // en cm
  age: number;
  gender: Gender;
  neck?: number; // en cm
  waist?: number; // en cm
}

interface BodyComposition {
  bmi: number;
  bodyFatPercentage: number;
}

const calculateBodyMetrics = ({
  weight,
  height,
  age,
  gender,
  neck,
  waist,
}: BodyMetrics): BodyComposition => {
  // Convertir altura a metros
  const heightInMeters = height / 100;
  const bmi = weight / (heightInMeters * heightInMeters);

  let bodyFatPercentage: number;

  // Si tenemos neck y waist, usamos la fórmula de la Marina de EE.UU.
  if (neck && waist && neck > 0 && waist > 0) {
    if (gender === "male") {
      bodyFatPercentage =
        495 /
          (1.0324 -
            0.19077 * Math.log10(waist - neck) +
            0.15456 * Math.log10(height)) -
        450;
    } else {
      // Para mujeres, sin cadera usamos una aproximación basada en hombres o la fórmula simple como fallback
      bodyFatPercentage =
        495 /
          (1.0324 -
            0.19077 * Math.log10(waist - neck) +
            0.15456 * Math.log10(height)) -
        450; // Aproximación
    }
  } else {
    // Fallback si no hay neck o waist
    bodyFatPercentage =
      gender === "male"
        ? 1.2 * bmi + 0.23 * age - 16.2
        : 1.2 * bmi + 0.23 * age - 5.4;
  }

  return {
    bmi: parseFloat(bmi.toFixed(2)),
    bodyFatPercentage: parseFloat(bodyFatPercentage.toFixed(2)),
  };
};

export default calculateBodyMetrics;
